export const REQUEST_CASE = 'request_case' as const
export const SUCCESS_CASE = 'success_case' as const
export const FAILURE_CASE = 'failure_case' as const

export default {
  REQUEST_CASE,
  SUCCESS_CASE,
  FAILURE_CASE
}
